import React from 'react';
import DENTToothPeriodontalLineDetail from './DENTToothPeriodontalLineDetail';
import DENTToothPeriodontalLineMouth from './DENTToothPeriodontalLineMouth';
import { Scale } from '../../../Base/Interfaces/Scale.interface';
import { PeriodontalToothView } from '../../Interfaces/PeriodontalToothView.type';
import { Tooth } from '../../../../graphql/graphql';

interface Props {
	tooth: Tooth;
	scale: Scale;
	view: PeriodontalToothView;
	isDetail: boolean;
	containerSize?: { w: number; h: number } | null;
	toothMap?: Map<number, Tooth>;
}

const DENTToothPeriodontalLine = ({
	tooth,
	scale,
	view,
	isDetail,
	containerSize,
	toothMap,
}: Props) => {
	if (isDetail) {
		return (
			<DENTToothPeriodontalLineDetail tooth={tooth} scale={scale} view={view} />
		);
	}

	if (toothMap && containerSize) {
		return (
			<DENTToothPeriodontalLineMouth
				tooth={tooth}
				scale={scale}
				view={view}
				containerSize={containerSize}
				toothMap={toothMap}
			/>
		);
	}

	return <></>;
};

export default DENTToothPeriodontalLine;
